// extracted by mini-css-extract-plugin
module.exports = {"ProductImage":"product-image_ProductImage__3k-tT","img":"product-image_img__2MPDl"};